/*! @license Firebase v4.2.0
Build: rev-d6b2db4
Terms: https://firebase.google.com/terms/ */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnlineMonitor = undefined;

var _assert = require('../../../utils/assert');

var _EventEmitter = require('./EventEmitter');

var _environment = require('../../../utils/environment');
/**
* Copyright 2017 Google Inc.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/


var __extends = undefined && undefined.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */


var OnlineMonitor = function (_super) {
  __extends(OnlineMonitor, _super);

  function OnlineMonitor() {
    var _this = _super.call(this, ['online']) || this;

    _this.online_ = true; // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
    // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
    // It would seem that the 'online' event does not always fire consistently. So we disable it
    // for Cordova.

    if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !(0, _environment.isMobileCordova)()) {
      window.addEventListener('online', function () {
        if (!_this.online_) {
          _this.online_ = true;

          _this.trigger('online', true);
        }
      }, false);
      window.addEventListener('offline', function () {
        if (_this.online_) {
          _this.online_ = false;

          _this.trigger('online', false);
        }
      }, false);
    }

    return _this;
  }

  OnlineMonitor.getInstance = function () {
    return new OnlineMonitor();
  };
  /**
   * @param {!string} eventType
   * @return {Array.<boolean>}
   */


  OnlineMonitor.prototype.getInitialEvent = function (eventType) {
    (0, _assert.assert)(eventType === 'online', 'Unknown event type: ' + eventType);
    return [this.online_];
  };
  /**
   * @return {boolean}
   */


  OnlineMonitor.prototype.currentlyOnline = function () {
    return this.online_;
  };

  return OnlineMonitor;
}(_EventEmitter.EventEmitter);

exports.OnlineMonitor = OnlineMonitor;